export const buttonTypes = [
	'primary',
	'success',
	'danger',
	'warning',
	'secondary',
	'black',
]